import MobileEarnPage from './mobile-earn-page';

export default function CinemaAdsPage() {
  return <MobileEarnPage />;
}
